import { useEffect } from 'react';
import { PAGE_SEO_ATTR, buildPageCanonicalUrl } from './pageSeo';

function getOrCreateOwnedDescription() {
  const owned = document.head.querySelector(
    `meta[name="description"][${PAGE_SEO_ATTR}="description"]`
  );
  if (owned) return { node: owned, created: false };

  const existing = document.head.querySelector('meta[name="description"]');
  if (existing) {
    existing.setAttribute(PAGE_SEO_ATTR, 'description');
    return { node: existing, created: false };
  }

  const node = document.createElement('meta');
  node.setAttribute('name', 'description');
  node.setAttribute(PAGE_SEO_ATTR, 'description');
  document.head.appendChild(node);
  return { node, created: true };
}

function getOrCreateOwnedCanonical() {
  const owned = document.head.querySelector(
    `link[rel="canonical"][${PAGE_SEO_ATTR}="canonical"]`
  );
  if (owned) return owned;

  const node = document.createElement('link');
  node.setAttribute('rel', 'canonical');
  node.setAttribute(PAGE_SEO_ATTR, 'canonical');
  document.head.appendChild(node);
  return node;
}

export function usePageSeo({ title, description, path }) {
  const canonical = buildPageCanonicalUrl(path);

  useEffect(() => {
    if (!title || !description || !canonical) return undefined;

    const previousTitle = document.title;
    document.title = title;

    const { node: meta, created: createdMeta } = getOrCreateOwnedDescription();
    const previousDescription = meta.getAttribute('content');
    meta.setAttribute(PAGE_SEO_ATTR, 'description');
    meta.setAttribute('content', description);

    const canonicalNode = getOrCreateOwnedCanonical();
    canonicalNode.setAttribute('href', canonical);

    return () => {
      document.title = previousTitle;
      if (createdMeta) {
        meta.remove();
      } else if (document.head.contains(meta)) {
        meta.removeAttribute(PAGE_SEO_ATTR);
        if (previousDescription != null) meta.setAttribute('content', previousDescription);
        else meta.removeAttribute('content');
      }
      document.head
        .querySelector(`link[rel="canonical"][${PAGE_SEO_ATTR}="canonical"]`)
        ?.remove();
    };
  }, [title, description, canonical]);
}
